import React, {useState, useEffect} from 'react';
import {
	Alert,
	Popover,
	SpaceBetween
} from "@amzn/awsui-components-console";
import PropertyFilter, { PropertyFilterProps } from "@amzn/awsui-components-console/property-filter";
import { PIPELINE_NAMES } from "../ResilienceWorkflow/PipelineNames";
import { getPipelineEntityPropertyFilterOptions } from "src/utils/AttributeUtils";
import { getRedirectUrlForSearch } from "src/utils/url";
import { FILTER_PROPS_FOR_ENTITY_SEARCH, GROUPS_FOR_ENTITY_SEARCH, HELP_FOR_SEARCH, PropertyFilteri18nStrings } from "src/constants/ComponentConstants";
import 'src/pages/RADWorkflow/radStyles.css';

export const SearchPropertyFilter = () => {
  const [query, setQuery] = useState<PropertyFilterProps.Query>({
    tokens: [],
    operation: "and"
  });
  const [searchDisable, setSearchDisable] = React.useState(false);
  const [isSearchValid, setIsSearchValid] = React.useState(true);

  useEffect(() => {
    if(query.tokens[0]) {
      setSearchDisable(true)
      const redirectUrl = getRedirectUrlForSearch(query.tokens[0])
      if(redirectUrl) {
        location.href = "../" + redirectUrl;
        setIsSearchValid(true)
      } else {
        setIsSearchValid(false)
      }
      setSearchDisable(false)
      setQuery({
        tokens: [],
        operation: "and"
      })
    }
  }, [query, isSearchValid]);

  return ( isSearchValid ? getEntitySearchPropertyFilter(setQuery, query, searchDisable) :  
    <SpaceBetween direction="horizontal" size="xs" >
        {getEntitySearchPropertyFilter(setQuery, query, searchDisable)}
        <Alert className="alert" dismissible type="error"> Please provide valid entity. <Popover content={HELP_FOR_SEARCH}>Click here for help</Popover></Alert>
    </SpaceBetween>
  );
}

const getEntitySearchPropertyFilter = (
  setQuery: React.Dispatch<React.SetStateAction<PropertyFilterProps.Query>>, 
  query: PropertyFilterProps.Query, 
  searchDisable: boolean
) => {

  return <PropertyFilter
      onChange={({ detail }) => { 
            setQuery(detail)}}
      hideOperations
      query={query}
      i18nStrings={PropertyFilteri18nStrings}
      disabled={searchDisable}
      tokenLimit={1}
      customGroupsText={GROUPS_FOR_ENTITY_SEARCH}
      filteringOptions={getPipelineEntityPropertyFilterOptions(PIPELINE_NAMES, "pipelineName")}
      filteringProperties={FILTER_PROPS_FOR_ENTITY_SEARCH}
    />
}